import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { User } from '@/Domain/api/User/dto/User.dto';
import { UserProfileForm } from '@/Domain/hooks/User/useUserProfile/useUserProfile.hook';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class UserApi {
  static myself = (): Promise<User> =>
    httpClient.get(Endpoint.user.myself).then(ApiMapper.toResponseData);

  static update = (form: Partial<UserProfileForm>): Promise<User> =>
    httpClient.patch(Endpoint.user.update, form).then(ApiMapper.toResponseData);

  static uploadAvatar = (avatar_image: string): Promise<User> =>
    httpClient.post(Endpoint.user.avatar, { avatar_image }).then(ApiMapper.toResponseData);

  static deleteAvatar = (): Promise<User> => httpClient.delete(Endpoint.user.avatar);
}
